var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    fill: "none",
    viewBox: "0 0 48 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    y: 0.613,
    fill: "#F2F4F7",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.08,
    strokeWidth: 0.75,
    d: "M.375 2.613C.375 1.715 1.103.988 2 .988h44c.898 0 1.625.727 1.625 1.625v44c0 .897-.727 1.625-1.625 1.625H2a1.625 1.625 0 0 1-1.625-1.625v-44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M32.4 26.58c1.478 1.104 2.8 3.886 2.8 5.6 0 .533-.39.966-.87.966h-.53m-5.6-11.095a3.199 3.199 0 0 0 0-5.544M13.67 33.146h15.326c.48 0 .87-.433.87-.967 0-3.356-2.803-6.076-8.533-6.076-5.73 0-8.533 2.72-8.533 6.076 0 .534.39.967.87.967Zm10.863-13.867a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPlaceholder);
export default __webpack_public_path__ + "static/media/team_placeholder.3b960a5e3d46e6611f33cd9f19d8d717.svg";
export { ForwardRef as ReactComponent };